<template>
  <div class="question-simple">
    <div class="mx-3">
      <strong class="d-block py-3 px-2 mt-2">{{ question.text }}</strong>
      <div class="row no-gutters">
        <div
          class="answer p-3 col uppercase smaller shadow-sm svg-sm pointer"
          v-for="answer of question.answer_options"
          :key="answer.id"
          @click.stop="submit(answer)"
          :class="{
            'col mx-2 text-center text-success': answer.id === 'yes',
            'col mx-2 text-center text-danger': answer.id === 'no',
            'col mx-2 text-center text-secondary': answer.id === 'unknown',
            'col-12 mb-2': answer.id !== 'yes' && answer.id !== 'no' && answer.id !== 'unknown'
          }"
        >
          <div
            v-if="
              answer.id === 'yes' ||
                answer.id === 'no' ||
                answer.id === 'unknown'
            "
          >
            <components :is="`${answer.id}-icon`"></components>
          </div>
          {{ answer.label }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UnknownIcon from '@/components/Icons/DoubleArrow'
import YesIcon from '@/components/Icons/Yes'
import NoIcon from '@/components/Icons/No'
export default {
  components: {
    YesIcon,
    NoIcon,
    UnknownIcon
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    nextCallback: {
      type: Function,
      required: true
    }
  },
  methods: {
    submit (answer) {
      this.nextCallback([answer.id])
    }
  }
}
</script>
<style lang="scss">
.question-simple {
  .answer {
    // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: all 0.2s;
    // &:hover {
    //   box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
    // }
    // svg {
    //   width: 16px;
    // }
  }
}
</style>
